// Mesquite Mafia: Stripe Escrow Checkout & Diamond Store
import { state, log, updateCurrencies } from '../core/state.js';
import { SFX, playSFX } from '../core/audio.js';
import { playActionSequence } from '../core/kinematics.js';
import { updateMissionProgress } from '../engine/missions.js';
import { syncStateToD1 } from './api.js';

export function getSessionToken() {
  return localStorage.getItem("mesquite_session_token") || localStorage.getItem("hometown_session_token") || "";
}

export let stripeStoreConfig = {
      provider: 'stripe',
      mode: 'sandbox',
      stripeConfigured: false
    };

export async function buyJewelry(name, cost, slot, armorBonus, shieldBonus, launderingBonus) {
      if (state.cred >= cost) {
        state.cred -= cost;
        SFX.vault();
        updateMissionProgress('bounty', 'high_roller', cost);
        updateCurrencies();
        playActionSequence({
          title: "VAULT TRANSACTION",
          icon: "👑",
          detail: `Equipped piece: ${name}`,
          rewardText: `-${cost} Cred Deducted`,
          shots: 0
        });
        log(`[VAULT]: Purchased & Equipped: ${name}!`);
        const token = getSessionToken();
        if (token) {
          try {
            await fetch('/api/vault', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
              body: JSON.stringify({ itemName: name, costCred: cost, slot: slot || 'neckwear', armorBonus: armorBonus || 0, shieldBonus: shieldBonus || 0, launderingBonus: launderingBonus || 0 })
            });
          } catch(e) {}
        }
        syncStateToD1();
      } else {
        playActionSequence({
          title: "CREDIT DECLINED",
          icon: "❌",
          detail: "Insufficient Street Cred for this piece.",
          rewardText: "Wire more in Clean Wire Store",
          shots: 0
        });
      }
    }

export async function giftAssociate(name, cost, giftId) {
      if (state.cred >= cost) {
        state.cred -= cost;
        SFX.lounge();
        updateMissionProgress('bounty', 'high_roller', cost);
        updateCurrencies();
        playActionSequence({
          title: "LOUNGE REPUTATION",
          icon: "👠",
          detail: `Favor gift delivered to ${name}`,
          rewardText: "+Syndicate Influence",
          shots: 0
        });
        log(`[LOUNGE]: Luxury gift sent to ${name}!`);
        const token = getSessionToken();
        if (token) {
          try {
            const resp = await fetch('/api/lounge', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
              body: JSON.stringify({ associateName: name, giftId: giftId || 'gift_1' })
            });
            const data = await resp.json();
            if (data.newLevel) log(`[LOUNGE]: ${name} reached Favor Level ${data.newLevel}!`);
          } catch(e) {}
        }
        syncStateToD1();
      } else {
        playActionSequence({
          title: "INSUFFICIENT CRED",
          icon: "❌",
          detail: "You need more cred to purchase this gift.",
          rewardText: "Visit Clean Wire Store",
          shots: 0
        });
      }
    }

export async function buyStorePack(packName, priceCents, cred, cash) {
      SFX.cash();
      state.cred += cred;
      state.cash += cash;
      updateCurrencies();
      playActionSequence({
        title: "CLEAN WIRE RECEIVED",
        icon: "💳",
        detail: `${packName} cleared federal routing!`,
        rewardText: `+💎 ${cred} Cred • +💵 $${cash.toLocaleString()} Cash`,
        shots: 0
      });
      log(`[STORE]: Wire transfer approved! +💎 ${cred} Cred, +💵 $${cash.toLocaleString()} Cash!`);
      const token = getSessionToken();
      if (token) {
        try {
          await fetch('/api/store', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify({ packName: packName || 'Pack', priceCents: priceCents || 0, credBonus: cred, cashBonus: cash })
          });
        } catch(e) {}
      }
      syncStateToD1();
    }

export async function listAssetForSale(name, askPrice) {
      SFX.click();
      playActionSequence({
        title: "AUCTION LISTING POSTED",
        icon: "🏛️",
        detail: `Posted "${name}" to secondary marketplace.`,
        rewardText: `Ask: 💎 ${askPrice.toLocaleString()} Cred`,
        shots: 0
      });
      log(`[MARKETPLACE]: Asset "${name}" listed for resale.`);
      const token = getSessionToken();
      if (token) {
        try {
          await fetch('/api/assets', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify({ action: 'list', assetId: 'ast_001', askPrice, currencyType: 'street_cred' })
          });
        } catch(e) {}
      }
      syncStateToD1();
    }

export async function pawnAsset(name, payout) {
      SFX.cash();
      state.cred += payout;
      updateCurrencies();
      playActionSequence({
        title: "INSTANT PAWN CLEARED",
        icon: "💎",
        detail: `Liquidated "${name}" into liquid cred.`,
        rewardText: `+💎 ${payout.toLocaleString()} Street Cred`,
        shots: 0
      });
      log(`[PAWN HOUSE]: Liquidated "${name}" for 💎 ${payout} Street Cred.`);
      const token = getSessionToken();
      if (token) {
        try {
          await fetch('/api/assets', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify({ action: 'pawn', assetId: 'ast_001' })
          });
        } catch(e) {}
      }
      syncStateToD1();
    }

export async function buyMarketListing(name, price) {
      if (state.cred >= price) {
        state.cred -= price;
        SFX.cash();
        updateCurrencies();
        playActionSequence({
          title: "ACQUIRED P2P ASSET",
          icon: "📜",
          detail: `Purchased "${name}" from secondary listing (5% City Hall tax included).`,
          rewardText: `Title & Deed transferred to vault`,
          shots: 1
        });
        log(`[MARKETPLACE]: Acquired rare asset "${name}". 5% City Hall escrow deducted.`);
        const token = getSessionToken();
        if (token) {
          try {
            await fetch('/api/assets', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
              body: JSON.stringify({ action: 'buy', listingId: 'lst_101' })
            });
          } catch(e) {}
        }
        syncStateToD1();
      } else {
        playActionSequence({
          title: "INSUFFICIENT CRED",
          icon: "❌",
          detail: "Cannot afford this secondary market asset.",
          rewardText: "Wire funds via Store",
          shots: 0
        });
      }
    }

export function buyTacticalAirdrop() {
      const cost = 50;
      if (state.cred < cost) {
        playActionSequence({
          title: "DIAMONDS REQUIRED",
          icon: "💎",
          detail: `Need ${cost} Diamonds (💎) to charter a tactical contraband airdrop.`,
          rewardText: "Get Diamonds via Venmo @ArkitechEVL",
          shots: 0
        });
        openVenmoStoreModal();
        return;
      }

      state.cred -= cost;
      state.product += 1500;
      state.scrap += 600;
      state.cash += 15000;
      updateCurrencies();
      playSFX('vault');
      syncStateToD1();

      log(`[AIRDROP]: Tactical cargo plane dropped high-grade supplies at Room 114 (+1,500 Product, +600 Scrap, +$15,000 Cash).`);
      playActionSequence({
        title: "MUNITIONS AIRDROP SECURED",
        icon: "🚁",
        detail: "Midnight contraband drop cleared over US-80 frontage!",
        rewardText: "+1,500 Product • +600 Scrap • +$15,000 Cash (-50 💎)",
        shots: 1
      });
    }

export async function initStoreConfig() {
      try {
        const res = await fetch('/api/store');
        if (res.ok) {
          stripeStoreConfig = await res.json();
          updateStoreStatusUI();
        }
      } catch (e) {}
    }

export function updateStoreStatusUI() {
      const badges = document.querySelectorAll('.stripe-gateway-badge');
      badges.forEach(badge => {
        if (stripeStoreConfig.stripeConfigured) {
          badge.innerHTML = '<span>🟢 <strong>STRIPE LIVE GATEWAY ACTIVE</strong> • Funds Safe & Guaranteed Delivery to Cloudflare D1</span><span style="font-size: 0.68rem; opacity: 0.85;">PCI-DSS Level 1</span>';
          badge.style.borderColor = '#10b981';
          badge.style.background = 'rgba(16, 185, 129, 0.15)';
          badge.style.color = '#6ee7b7';
        } else {
          badge.innerHTML = '<span>🟡 <strong>STRIPE ESCROW SANDBOX ACTIVE</strong> • Instant Safe Testing & Verified D1 Delivery</span><span style="font-size: 0.68rem; opacity: 0.85;">Escrow Verified</span>';
          badge.style.borderColor = '#eab308';
          badge.style.background = 'rgba(234, 179, 8, 0.15)';
          badge.style.color = '#fde047';
        }
      });
    }

export function openVenmoStoreModal() {
      const m = document.getElementById('modal-venmo-store');
      if (m) {
        m.style.display = 'flex';
        playSFX('click');
        initStoreConfig();
      }
    }

export function closeVenmoStoreModal() {
      const m = document.getElementById('modal-venmo-store');
      if (m) {
        m.style.display = 'none';
        playSFX('click');
      }
    }

export async function initiateStorePurchase(packId, btnElement) {
      playSFX('click');
      const originalText = btnElement ? btnElement.innerHTML : '';
      if (btnElement) {
        btnElement.disabled = true;
        btnElement.innerHTML = '⏳ Securing Stripe Session...';
      }

      try {
        const token = getSessionToken() || (state && state.session_token) || 'anon_player';
        const res = await fetch('/api/store', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          },
          body: JSON.stringify({ action: 'checkout', packId: packId })
        });

        const data = await res.json();

        if (!res.ok || data.error) {
          alert("Payment Error: " + (data.error || "Unable to initialize payment session."));
          if (btnElement) {
            btnElement.disabled = false;
            btnElement.innerHTML = originalText;
          }
          return;
        }

        // Live Stripe Hosted Checkout Redirect
        if (data.status === 'stripe_ready' && data.checkoutUrl) {
          log(`[STRIPE]: Redirecting to encrypted checkout for ${data.pack.title}...`);
          window.location.href = data.checkoutUrl;
          return;
        }

        // Sandbox Escrow Instant Clearance
        if (data.status === 'sandbox_cleared') {
          playSFX('cash');
          state.cred += data.credBonus;
          state.cash += data.cashBonus;
          if (data.scrapBonus) state.scrap += data.scrapBonus;
          updateCurrencies();

          playActionSequence({
            title: "ESCROW DELIVERY CONFIRMED",
            icon: "🛡️",
            detail: `${data.packName} cleared and verified!`,
            rewardText: `+💎 ${data.credBonus.toLocaleString()} Diamonds • +💵 $${data.cashBonus.toLocaleString()}` + (data.scrapBonus ? ` • +⚙️ ${data.scrapBonus.toLocaleString()} Scrap` : ''),
            shots: 0
          });

          showPaymentReceiptModal({
            title: "PAYMENT SECURED & ASSETS DELIVERED",
            packName: data.packName,
            transactionId: data.transactionId,
            credAdded: data.credBonus,
            cashAdded: data.cashBonus,
            scrapAdded: data.scrapBonus,
            bonusAsset: data.bonusAsset,
            providerNotice: data.notice
          });

          log(`[ESCROW STORE]: ${data.packName} credited successfully (TX: ${data.transactionId}).`);
          syncStateToD1();
          closeVenmoStoreModal();
        }

      } catch (err) {
        alert("Payment Gateway Connection Error: " + err.message);
      } finally {
        if (btnElement) {
          btnElement.disabled = false;
          btnElement.innerHTML = originalText;
        }
      }
    }

export function claimVenmoPackage(tierName, priceDollars, credAmount, scrapBonus = 0, cashBonus = 0) {
      const mapping = {
        'The Porch Roll': 'porch_roll',
        'The 635 Stash': 'motel_roll',
        'Mesquite Syndicate Vault': 'courier_stash'
      };
      const packId = mapping[tierName] || 'porch_roll';
      initiateStorePurchase(packId, null);
    }

export async function checkPaymentReturnStatus() {
      const urlParams = new URLSearchParams(window.location.search);
      const paymentStatus = urlParams.get('payment_status');
      const sessionId = urlParams.get('session_id');

      if (!paymentStatus) return;

      // Clean URL query parameters
      window.history.replaceState({}, document.title, window.location.pathname);

      if (paymentStatus === 'cancelled') {
        playActionSequence({
          title: "TRANSACTION CANCELLED",
          icon: "✕",
          detail: "Stripe checkout was cancelled. No client funds were charged.",
          rewardText: "Syndicate vault balance unchanged.",
          shots: 0
        });
        return;
      }

      if (paymentStatus === 'success' && sessionId) {
        try {
          const token = getSessionToken() || '';
          const res = await fetch(`/api/store?action=verify&session_id=${encodeURIComponent(sessionId)}`, {
            headers: { 'Authorization': 'Bearer ' + token }
          });
          const result = await res.json();

          if (result.status === 'delivered') {
            playSFX('cash');
            if (result.credBonus) state.cred += result.credBonus;
            if (result.cashBonus) state.cash += result.cashBonus;
            if (result.scrapBonus) state.scrap += result.scrapBonus;
            updateCurrencies();

            showPaymentReceiptModal({
              title: "STRIPE PAYMENT CONFIRMED & DELIVERED",
              packName: result.packName || "Syndicate Vault Pack",
              transactionId: result.transactionId || sessionId,
              credAdded: result.credBonus || 0,
              cashAdded: result.cashBonus || 0,
              scrapAdded: result.scrapBonus || 0,
              providerNotice: "Verified via Stripe 256-Bit SSL Escrow. Assets cryptographically committed to Cloudflare D1."
            });

            log(`[STRIPE DELIVERY]: Session ${sessionId} confirmed! Vault updated.`);
            syncStateToD1();
          }
        } catch (e) {
          console.error("Payment return verification error:", e);
        }
      }
    }

export function showPaymentReceiptModal(receipt) {
      let modal = document.getElementById('modal-payment-receipt');
      if (!modal) {
        modal = document.createElement('div');
        modal.id = 'modal-payment-receipt';
        modal.className = 'tactical-modal-overlay';
        modal.style.display = 'none';
        document.body.appendChild(modal);
      }

      modal.innerHTML = `
        <div class="tactical-modal-box" style="max-width: 580px; border-color: #10b981; box-shadow: 0 20px 60px rgba(0,0,0,0.95), 0 0 35px rgba(16,185,129,0.35);">
          <div class="tactical-modal-header" style="border-bottom: 1px solid rgba(16,185,129,0.3);">
            <div class="tactical-modal-title" style="color: #6ee7b7; display: flex; align-items: center; gap: 8px;">
              <span>🛡️</span>
              <span>${receipt.title}</span>
            </div>
            <button onclick="document.getElementById('modal-payment-receipt').style.display='none'" style="background: none; border: none; color: #94a3b8; font-size: 1.3rem; cursor: pointer;">✕</button>
          </div>
          <div style="padding: 14px 0;">
            <div style="background: rgba(16, 185, 129, 0.1); border: 1px solid #10b981; border-radius: 8px; padding: 12px; margin-bottom: 14px; text-align: center;">
              <div style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; color: #a7f3d0; font-weight: 800;">Cryptographic Delivery Ledger</div>
              <div style="font-size: 1.25rem; font-weight: 900; color: #fff; margin: 4px 0;">${receipt.packName}</div>
              <div style="font-size: 0.74rem; color: #6ee7b7; font-family: monospace;">TX: ${receipt.transactionId}</div>
            </div>
            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(130px, 1fr)); gap: 10px; margin-bottom: 14px;">
              ${receipt.credAdded ? `<div style="background: rgba(15,23,42,0.8); border: 1px solid rgba(56,189,248,0.3); border-radius: 6px; padding: 10px; text-align: center;"><div style="font-size: 0.68rem; color: #94a3b8;">Diamonds Credited</div><div style="font-size: 1.15rem; font-weight: 900; color: #38bdf8;">+💎 ${receipt.credAdded.toLocaleString()}</div></div>` : ''}
              ${receipt.cashAdded ? `<div style="background: rgba(15,23,42,0.8); border: 1px solid rgba(34,197,94,0.3); border-radius: 6px; padding: 10px; text-align: center;"><div style="font-size: 0.68rem; color: #94a3b8;">Cash Credited</div><div style="font-size: 1.15rem; font-weight: 900; color: #22c55e;">+💵 $${receipt.cashAdded.toLocaleString()}</div></div>` : ''}
              ${receipt.scrapAdded ? `<div style="background: rgba(15,23,42,0.8); border: 1px solid rgba(251,191,36,0.3); border-radius: 6px; padding: 10px; text-align: center;"><div style="font-size: 0.68rem; color: #94a3b8;">Scrap Credited</div><div style="font-size: 1.15rem; font-weight: 900; color: #fbbf24;">+⚙️ ${receipt.scrapAdded.toLocaleString()}</div></div>` : ''}
            </div>
            ${receipt.bonusAsset ? `<div style="background: rgba(192,132,252,0.15); border: 1px solid #c084fc; border-radius: 6px; padding: 10px 14px; margin-bottom: 14px; display: flex; align-items: center; gap: 10px;"><span style="font-size: 1.4rem;">👑</span><div><div style="font-size: 0.68rem; color: #e9d5ff; font-weight: 800;">BONUS ASSET UNLOCKED</div><div style="font-size: 0.95rem; font-weight: 900; color: #fff;">${receipt.bonusAsset.itemName} (${receipt.bonusAsset.rarity})</div></div></div>` : ''}
            <div style="font-size: 0.74rem; color: #94a3b8; line-height: 1.4; background: rgba(0,0,0,0.3); padding: 10px 14px; border-radius: 6px;">
              🛡️ <strong>Funds Safety Confirmation:</strong> Payment cleared through Stripe's certified PCI-DSS payment wall. Delivery verified and atomically committed to Cloudflare D1 database.
            </div>
          </div>
          <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
            <button onclick="document.getElementById('modal-payment-receipt').style.display='none'" style="background: #10b981; border: none; color: #fff; padding: 9px 24px; border-radius: 6px; font-weight: 900; font-size: 0.85rem; cursor: pointer;">
              RETURN TO SYNDICATE
            </button>
          </div>
        </div>
      `;
      modal.style.display = 'flex';
      playSFX('cash');
    }

